import React from 'react'
import Image from '@/components/base/image'
import { AsgBrandCardListProps } from './types'
import { Column, Row } from '@/components/base/gridview'

const AsgRewards: React.FunctionComponent<AsgBrandCardListProps> = (props) => {
  return (
    <Row className="rewards-list" gutter="lg">
      {props.data.map((item, index) => (
        <Column
          key={index}
          xs={{ size: 12 }}
          sm={{ size: 4 }}
          xl={{ size: 4 }}
          className={'reward-item'}
        >
          <Image
            alt={item.title}
            {...item.image}
            style={{ borderRadius: '30px' }}
          />
          <div className="info">
            <div className="info-head">
              <span className="title">{item.title}</span>
              <span className="date">
                {(() => {
                  const date = new Date(item.date)
                  const month = date.toLocaleString('default', {
                    month: 'long',
                  })
                  const year = date.getFullYear()
                  return `${month} ${year}`
                })()}{' '}
                | {item.location}
              </span>
            </div>

            <span className="desc">
              <div
                dangerouslySetInnerHTML={{
                  __html: item.description,
                }}
              ></div>
            </span>
            <span className="platform">{item.platform}</span>
          </div>
        </Column>
      ))}
    </Row>
  )
}

export default AsgRewards
